import styled from "styled-components";

const StyledTimePicker = styled.div`
    .ant-picker {
        height: 32px !important;
        width: 100% !important;
    }

    .ant-picker-input {
        height: 30px !important;
    }

    .custom-time-picker-popup .ant-picker-time-panel-column > li {
        color: rgba(172, 240, 1, 0.24) !important;
        padding: 4px 8px !important;
    }

    .custom-time-picker-popup .ant-picker-time-panel-column > li:hover {
        background-color: rgba(172, 240, 1, 0.24) !important;
    }

    .custom-time-picker-popup
        .ant-picker-time-panel-column
        > li.ant-picker-time-panel-cell-selected {
        background-color: rgba(172, 240, 1, 0.24) !important;
        font-weight: bold !important;
    }

    .custom-time-picker-popup
        .ant-picker-time-panel-column
        > li.ant-picker-time-panel-cell-selected:hover {
        background-color: rgba(172, 240, 1, 0.24) !important;
    }

    .custom-time-picker-popup
        .ant-picker-time-panel-column
        > li.ant-picker-time-panel-cell-selected
        .ant-picker-time-panel-cell-inner {
        background-color: rgba(172, 240, 1, 0.24) !important;
    }

    .custom-time-picker-popup .ant-btn-primary {
        background-color: #aef001 !important;
        border-color: #aef001 !important;
        color: #000 !important;
    }

    .custom-time-picker-popup .ant-btn-primary:hover,
    .custom-time-picker-popup .ant-btn-primary:focus {
        background-color: #aef001 !important;
        border-color: #aef001 !important;
        color: #000 !important;
    }

    .custom-time-picker-popup .ant-btn-link {
        color: rgba(172, 240, 1, 0.24) !important;
        border: none !important;
    }

    .custom-time-picker-popup .ant-btn-link:hover,
    .custom-time-picker-popup .ant-btn-link:focus {
        color: rgba(0, 0, 0, 0.7) !important;
        background: #aef001 !important;
    }
`;

export {StyledTimePicker};
